import React, { Component } from "react";
import BlockUi from "react-block-ui";
import CountUp from "react-countup";
import { Loader } from "react-loaders";
import Select from "react-select";
import { Card, CardHeader, Col, Row } from "reactstrap";

const options = [
  { value: "1", label: "All" },
  { value: "2", label: "Today" },
  { value: "3", label: "Last Week" },
  { value: "4", label: "Last 30 Days" },
  { value: "5", label: "Last 3 Months" },
  { value: "6", label: "Last Year" },
];

const SECOND_IN_MILLIS = 1000;
const MINUTE_IN_MILLIS = SECOND_IN_MILLIS * 60;
const HOUR_IN_MILLIS = MINUTE_IN_MILLIS * 60;
const DAY_IN_MILLIS = HOUR_IN_MILLIS * 24;
const WEEK_IN_MILLIS = DAY_IN_MILLIS * 7;

class StationStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: props.selectedOption
        ? options[props.selectedOption]
        : options[1],
    };
  }

  handleChange = (selectedOption) => {
    this.props.onChangeDate(selectedOption);
    this.setState({ selectedOption });
  };

  parseTime(duration) {
    let formattedTime;

    if (duration < SECOND_IN_MILLIS) {
      formattedTime = {
        value: parseInt(duration, 10),
        suffix: "ms",
      };
    } else if (duration < MINUTE_IN_MILLIS) {
      formattedTime = {
        value: parseInt(duration / SECOND_IN_MILLIS, 10),
        suffix: "s",
      };
    } else if (duration < HOUR_IN_MILLIS) {
      formattedTime = {
        value: parseInt(duration / MINUTE_IN_MILLIS, 10),
        suffix: "m",
      };
    } else if (duration < DAY_IN_MILLIS) {
      formattedTime = {
        value: parseInt(duration / HOUR_IN_MILLIS, 10),
        suffix: "h",
      };
    } else if (duration < WEEK_IN_MILLIS) {
      formattedTime = {
        value: parseInt(duration / DAY_IN_MILLIS, 10),
        suffix: "d",
      };
    } else {
      formattedTime = {
        value: parseInt(duration / WEEK_IN_MILLIS, 10),
        suffix: "w",
      };
    }

    return formattedTime;
  }

  render() {
    const { selectedOption } = this.state;
    let { statistics } = this.props;

    let totals = 0;
    let avg = 0;
    let min = 0;
    let max = 0;
    let totalsDistinct = 0;
    let totalPassed = 0;
    let failedDistinct = 0;
    let failed = 0;
    let passedDistinct = 0;

    if (
      statistics !== undefined &&
      statistics != null &&
      Object.keys(statistics).length > 0
    ) {
      if (statistics.total.length > 0) {
        var totalsCount = statistics.total[0];

        avg = totalsCount.avg;
        min = totalsCount.min;
        max = totalsCount.max;
        totals = totalsCount.total;
      }

      if (statistics.totalDistinct.length > 0) {
        totalsDistinct = statistics.totalDistinct[0].totalDistinct;
      }
      if (statistics.passed.length > 0) {
        let passedObj = statistics.passed[0];
        totalPassed = passedObj.totalPassed;
        if (passedObj.min) {
          min = passedObj.min;
        }
        if (passedObj.max) {
          max = passedObj.max;
        }
      }
      if (statistics.passedDistinct.length > 0) {
        passedDistinct = statistics.passedDistinct[0].passedDistinct;
      }
      if (statistics.failedDistinct.length > 0) {
        failedDistinct = statistics.failedDistinct[0].failedDistinct;
      }
      if (statistics.failed.length > 0) {
        failed = statistics.failed[0].totalFailed;
      }
    }

    /***************************** RAW VALUES *****************************/
    const total = statistics !== undefined && totals !== undefined ? totals : 0;
    const average = statistics !== undefined && avg && totals > 0 ? avg : 0;
    const minTime = statistics !== undefined && min && totals > 0 ? min : 0;
    const maxTime = statistics !== undefined && max && totals > 0 ? max : 0;
    const totalDistinct =
      statistics !== undefined && totalsDistinct && totals > 0
        ? totalsDistinct
        : 0;
    /***************************** PARSED VALUES *****************************/
    const averageObj = this.parseTime(average);
    const averageValue = averageObj.value;
    const averageSuffix = averageObj.suffix;

    const minObj = this.parseTime(minTime);
    const minValue = minObj.value;
    const minSuffix = minObj.suffix;

    const maxObj = this.parseTime(maxTime);
    const maxValue = maxObj.value;
    const maxSuffix = maxObj.suffix;
    const totalYield =
      statistics !== undefined && totalPassed !== undefined && totalPassed !== 0
        ? (totalPassed / total) * 100
        : 0;
    const finalYield =
      statistics !== undefined &&
      passedDistinct !== undefined &&
      passedDistinct !== 0
        ? (passedDistinct / totalDistinct) * 100
        : 0;

    return (
      <BlockUi
        tag="div"
        blocking={this.props.blocking}
        loader={<Loader active type={this.props.loaderType} />}
      >
        <Card className="mb-3">
          <CardHeader className="card-header-tab z-index-11">
            <div className="card-header-title">
              <i className="header-icon lnr-clock"> </i>
              Production
            </div>
            <div className="btn-actions-pane-right text-capitalize">
              <span className="d-inline-block ml-2" style={{ width: 200 }}>
                <Select
                  value={selectedOption}
                  onChange={this.handleChange}
                  options={options}
                />
              </span>
            </div>
          </CardHeader>
          <Row className="no-gutters pb-3">
            <Row>
              <Col sm="12" md="6" xl={this.props.elemSize}>
                <div
                  className="card no-shadow rm-border bg-transparent widget-chart text-left"
                  style={{ paddingBottom: "4px" }}
                >
                  <div
                    className="icon-wrapper rounded-circle"
                    style={{ height: "54px" }}
                  >
                    <div className="icon-wrapper-bg opacity-7 bg-primary" />
                    <i className={this.props.icon} />
                  </div>
                  <div className="widget-chart-content">
                    <div className="widget-subheading">
                      <b style={{ color: "black" }}>Total {this.props.title}</b>
                    </div>
                    <div className="widget-subheading">
                      <CountUp
                        start={0}
                        end={totalsDistinct}
                        separator=" "
                        decimals={0}
                        decimal="."
                        prefix=""
                        useEasing={true}
                        suffix=""
                        duration="2"
                      />
                    </div>
                  </div>
                </div>
                <div className="divider m-0 d-md-none d-sm-block" />
              </Col>
              <Col sm="12" md="6" xl={this.props.elemSize}>
                <div
                  className="card no-shadow rm-border bg-transparent widget-chart text-left"
                  style={{ paddingBottom: "4px" }}
                >
                  <div
                    className="icon-wrapper rounded-circle"
                    style={{ height: "54px" }}
                  >
                    <div className="icon-wrapper-bg opacity-7 bg-happy-green " />
                    <i className="lnr-checkmark-circle text-white" />
                  </div>
                  <div className="widget-chart-content">
                    <div className="widget-subheading">
                      <b style={{ color: "black" }}>
                        Passed {this.props.title}
                      </b>
                    </div>
                    <div className="widget-subheading">
                      <CountUp
                        start={0}
                        end={passedDistinct}
                        separator=" "
                        decimals={0}
                        decimal="."
                        prefix=""
                        useEasing={true}
                        suffix=""
                        duration="2"
                      />
                    </div>
                  </div>
                </div>
                <div className="divider m-0 d-md-none d-sm-block" />
              </Col>
              <Col sm="12" md="6" xl={this.props.elemSize}>
                <div
                  className="card no-shadow rm-border bg-transparent widget-chart text-left"
                  style={{ paddingBottom: "4px" }}
                >
                  <div
                    className="icon-wrapper rounded-circle"
                    style={{ height: "54px" }}
                  >
                    <div className="icon-wrapper-bg opacity-8 bg-love-kiss-fail" />
                    <i className="lnr-cross text-white" />
                  </div>
                  <div className="widget-chart-content">
                    <div className="widget-subheading">
                      <b style={{ color: "black" }}>
                        Failed {this.props.title}
                      </b>
                    </div>
                    <div className="widget-subheading">
                      <CountUp
                        start={0}
                        end={failedDistinct}
                        separator=" "
                        decimals={0}
                        decimal="."
                        prefix=""
                        useEasing={true}
                        suffix=""
                        duration="2"
                      />
                    </div>
                  </div>
                </div>
                <div className="divider m-0 d-md-none d-sm-block" />
              </Col>
              <Col sm="12" md="6" xl={this.props.elemSize}>
                <div
                  className="card no-shadow rm-border bg-transparent widget-chart text-left"
                  style={{ paddingBottom: "4px" }}
                >
                  <div
                    className="icon-wrapper rounded-circle"
                    style={{ height: "54px" }}
                  >
                    <div className="icon-wrapper-bg opacity-10 bg-happy-fisher-2" />
                    <i className="lnr-history text-white" />
                  </div>
                  <div className="widget-chart-content">
                    <div className="widget-subheading">
                      <b style={{ color: "black" }}>Yield {this.props.title}</b>
                    </div>
                    <div className="widget-subheading">
                      <CountUp
                        key={Math.random()}
                        start={0}
                        end={finalYield}
                        separator=" "
                        decimals={0}
                        decimal="."
                        prefix=""
                        useEasing={true}
                        suffix="%"
                        duration="2"
                      />
                    </div>
                  </div>
                </div>
                <div className="divider m-0 d-md-none d-sm-block" />
              </Col>

              <Col sm="12" md="6" xl={this.props.elemSize}>
                <div
                  className="card no-shadow rm-border bg-transparent widget-chart text-left"
                  style={{ paddingBottom: "4px" }}
                >
                  <div
                    className="icon-wrapper rounded-circle"
                    style={{ height: "54px" }}
                  >
                    <div className="icon-wrapper-bg opacity-7 bg-primary" />
                    <i className={this.props.icon} />
                  </div>
                  <div className="widget-chart-content">
                    <div className="widget-subheading">
                      <b style={{ color: "black" }}>Total Tests</b>
                    </div>
                    <div className="widget-subheading">
                      <CountUp
                        start={0}
                        end={totals}
                        separator=" "
                        decimals={0}
                        decimal="."
                        prefix=""
                        useEasing={true}
                        suffix=""
                        duration="2"
                      />
                    </div>
                  </div>
                </div>
                <div className="divider m-0 d-md-none d-sm-block" />
              </Col>
              <Col sm="12" md="6" xl={this.props.elemSize}>
                <div
                  className="card no-shadow rm-border bg-transparent widget-chart text-left"
                  style={{ paddingBottom: "4px" }}
                >
                  <div
                    className="icon-wrapper rounded-circle"
                    style={{ height: "54px" }}
                  >
                    <div className="icon-wrapper-bg opacity-7 bg-happy-green " />
                    <i className="lnr-checkmark-circle text-white" />
                  </div>
                  <div className="widget-chart-content">
                    <div className="widget-subheading">
                      <b style={{ color: "black" }}>Passed Tests</b>
                    </div>
                    <div className="widget-subheading">
                      <CountUp
                        start={0}
                        end={totalPassed}
                        separator=" "
                        decimals={0}
                        decimal="."
                        prefix=""
                        useEasing={true}
                        suffix=""
                        duration="2"
                      />
                    </div>
                  </div>
                </div>
                <div className="divider m-0 d-md-none d-sm-block" />
              </Col>
              <Col sm="12" md="6" xl={this.props.elemSize}>
                <div
                  className="card no-shadow rm-border bg-transparent widget-chart text-left"
                  style={{ paddingBottom: "4px" }}
                >
                  <div
                    className="icon-wrapper rounded-circle"
                    style={{ height: "54px" }}
                  >
                    <div className="icon-wrapper-bg opacity-8 bg-love-kiss-fail" />
                    <i className="lnr-cross text-white" />
                  </div>
                  <div className="widget-chart-content">
                    <div className="widget-subheading">
                      <b style={{ color: "black" }}>Failed Tests</b>
                    </div>
                    <div className="widget-subheading">
                      <CountUp
                        start={0}
                        end={failed}
                        separator=" "
                        decimals={0}
                        decimal="."
                        prefix=""
                        useEasing={true}
                        suffix=""
                        duration="2"
                      />
                    </div>
                  </div>
                </div>
                <div className="divider m-0 d-md-none d-sm-block" />
              </Col>
              <Col sm="12" md="6" xl={this.props.elemSize}>
                <div
                  className="card no-shadow rm-border bg-transparent widget-chart text-left"
                  style={{ paddingBottom: "4px" }}
                >
                  <div
                    className="icon-wrapper rounded-circle"
                    style={{ height: "54px" }}
                  >
                    <div className="icon-wrapper-bg opacity-10 bg-night-fade" />
                    <i className="lnr-undo text-white" />
                  </div>
                  <div className="widget-chart-content">
                    <div className="widget-subheading">
                      <b style={{ color: "black" }}>Yield Tests</b>
                    </div>
                    <div className="widget-subheading">
                      <CountUp
                        key={Math.random()}
                        start={0}
                        end={totalYield}
                        separator=" "
                        decimals={0}
                        decimal="."
                        prefix=""
                        useEasing={true}
                        suffix="%"
                        duration="2"
                      />
                    </div>
                  </div>
                </div>
                <div className="divider m-0 d-md-none d-sm-block" />
              </Col>

              <Col sm="12" md="6" xl={this.props.elemSize}>
                <div
                  className="card no-shadow rm-border bg-transparent widget-chart text-left"
                  style={{ paddingBottom: "4px" }}
                >
                  <div
                    className="icon-wrapper rounded-circle"
                    style={{ height: "54px" }}
                  >
                    <div className="icon-wrapper-bg opacity-9 bg-sunny-morning" />
                    <i className="lnr-rocket text-white" />
                  </div>
                  <div className="widget-chart-content">
                    <div className="widget-subheading">
                      <b style={{ color: "black" }}>Fastest Pass</b>
                    </div>
                    <div className="widget-subheading">
                      <CountUp
                        key={Math.random()}
                        start={0}
                        end={minValue}
                        separator=" "
                        decimals={0}
                        decimal="."
                        prefix=""
                        useEasing={true}
                        suffix={minSuffix}
                        duration="2"
                      />
                    </div>
                  </div>
                </div>
                <div className="divider m-0 d-md-none d-sm-block" />
              </Col>
              <Col sm="12" md="6" xl={this.props.elemSize}>
                <div
                  className="card no-shadow rm-border bg-transparent widget-chart text-left"
                  style={{ paddingBottom: "4px" }}
                >
                  <div
                    className="icon-wrapper rounded-circle"
                    style={{ height: "54px" }}
                  >
                    <div className="icon-wrapper-bg opacity-5 bg-midnight-bloom" />
                    <i className="lnr-bug text-white" />
                  </div>
                  <div className="widget-chart-content">
                    <div className="widget-subheading">
                      <b style={{ color: "black" }}>Slowest Pass</b>
                    </div>
                    <div className="widget-subheading">
                      <CountUp
                        key={Math.random()}
                        start={0}
                        end={maxValue}
                        separator=" "
                        decimals={0}
                        decimal="."
                        prefix=""
                        useEasing={true}
                        suffix={maxSuffix}
                        duration="2"
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm="12" md="6" xl={this.props.elemSize}>
                <div
                  className="card no-shadow rm-border bg-transparent widget-chart text-left"
                  style={{ paddingBottom: "4px" }}
                >
                  <div
                    className="icon-wrapper rounded-circle"
                    style={{ height: "54px" }}
                  >
                    <div className="icon-wrapper-bg opacity-7 bg-strong-bliss" />
                    <i className="lnr-hourglass text-white" />
                  </div>
                  <div className="widget-chart-content">
                    <div className="widget-subheading">
                      <b style={{ color: "black" }}>Average Time (Pass+Fail)</b>
                    </div>
                    <div className="widget-subheading">
                      <CountUp
                        key={Math.random()}
                        start={0}
                        end={averageValue}
                        separator=" "
                        decimals={0}
                        decimal="."
                        prefix=""
                        useEasing={true}
                        suffix={averageSuffix}
                        duration="2"
                      />
                    </div>
                  </div>
                </div>
                <div className="divider m-0 d-md-none d-sm-block" />
              </Col>
            </Row>
          </Row>
        </Card>
      </BlockUi>
    );
  }
}

export default StationStatistics;



// WEBPACK FOOTER //
// ./src/Stations/Statistics.jsx